import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { SUPPORT_PHONE, SUPPORT_PHONE_TEL } from '../constants/contact';
import { Plus, Minus, Phone, Mail, Clock } from 'lucide-react';
import { ScrollReveal } from './ScrollReveal';
import './faqs.css';
import { CHAT_FAQS } from '../data/chatKnowledge';

const faqs = CHAT_FAQS.map(({ question, answer }) => ({ question, answer }));

const FAQs = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const toggleFaq = (index) => {
    setOpenIndex((prev) => (prev === index ? -1 : index));
  };

  return (
    <section className="faq-page" id="faqs">
      <div className="faq-layout">
        <aside className="faq-aside">
          <ScrollReveal y={24}>
            <p className="faq-aside-label">Help &amp; support</p>
            <h1 className="faq-aside-title">Got questions? We&apos;ve got answers.</h1>
            <p className="faq-aside-text">
              Everything you need to know about applying, eligibility, repayment, and more —
              all in one place.
            </p>

            <div className="faq-help-box">
              <h2>Need direct help?</h2>
              <ul>
                <li>
                  <Phone size={16} aria-hidden="true" />
                  <a href={`tel:${SUPPORT_PHONE_TEL}`}>{SUPPORT_PHONE}</a>
                </li>
                <li>
                  <Mail size={16} aria-hidden="true" />
                  <a href="mailto:info@credit99.com">info@credit99.com</a>
                </li>
                <li>
                  <Clock size={16} aria-hidden="true" />
                  <span>Mon–Sat · 10 AM – 7 PM</span>
                </li>
              </ul>
              <Link to="/contact-us" className="faq-aside-link">
                Go to Contact Us
              </Link>
            </div>
          </ScrollReveal>
        </aside>

        <div className="faq-main">
          <ol className="faq-accordion">
            {faqs.map((faq, index) => {
              const isOpen = openIndex === index;
              const num = String(index + 1).padStart(2, '0');

              return (
                <li
                  key={faq.question}
                  className={`faq-row${isOpen ? ' faq-row--open' : ''}`}
                >
                  <button
                    type="button"
                    className="faq-row-btn"
                    onClick={() => toggleFaq(index)}
                    aria-expanded={isOpen}
                  >
                    <span className="faq-row-num">{num}</span>
                    <span className="faq-row-q">{faq.question}</span>
                    <span className="faq-row-icon" aria-hidden="true">
                      {isOpen ? <Minus size={18} /> : <Plus size={18} />}
                    </span>
                  </button>
                  <div className="faq-row-body" aria-hidden={!isOpen}>
                    <p>{faq.answer}</p>
                  </div>
                </li>
              );
            })}
          </ol>
        </div>
      </div>
    </section>
  );
};

export default FAQs;
